export default Object.freeze({
  baseURL: process.env.REACT_APP_API_SERVER,
});
